// ./01 - PROJETOS DEV/meu-controle-de-estoque/src/components/Header.jsx

import React from 'react';

const Header = ({ currentView, setView, onLogout, isAdmin, userEmail }) => {
    
    const viewTitles = {
        dashboard: 'Painel de Controle',
        registros: 'Gerenciamento de Produtos',
        inventory: 'Painel de Estoque',
        sales: 'Relatório de Vendas',
        customers: 'Gestão de Clientes',
        customerDetail: 'Detalhes do Cliente',
        financeiro: 'Recebimentos', // Atualizado de Fluxo de Caixa para Recebimentos
        compromissos: 'Compromissos Financeiros',
        tesouraria: 'Controle de Caixa e Tesouraria', // Nova aba
        admin: 'Painel de Administração'
    };

    return (
        <header className="mb-6">
            
            {/* --- Bloco de Saudação Fixo com Estilos --- */}
            <div className="mb-4 p-4 rounded-lg bg-[#FFFFFF]">
                <h1 className="text-xl font-semibold text-[#a17772] text-center sm:text-left">
                    {`Olá, ${userEmail || 'Usuário'}`}
                </h1>
                <p className="text-sm text-gray-600 mt-1 text-center sm:text-left">
                    Sua Loja Está Organizada e Sob Controle.
                </p>
            </div>

            {/* --- Título da Página Atual --- */}
            {currentView !== 'dashboard' && (
                <h2 className="text-2xl font-bold text-gray-800 text-center sm:text-left">
                    {viewTitles[currentView] || 'Página Atual'}
                </h2>
            )}

            <nav className="mt-6 border-b border-gray-200 flex justify-between items-center flex-wrap">
                <div className="flex items-center flex-wrap justify-center sm:justify-start">
                    <button 
                        onClick={() => setView('dashboard')} 
                        className={`nav-button py-2 px-3 sm:px-4 font-semibold ${currentView === 'dashboard' ? 'active' : ''}`}
                    >
                        Início
                    </button>
                    <button 
                        onClick={() => setView('registros')} 
                        className={`nav-button py-2 px-3 sm:px-4 font-semibold ${currentView === 'registros' ? 'active' : ''}`}
                    >
                        Registros
                    </button>
                    <button 
                        onClick={() => setView('inventory')} 
                        className={`nav-button py-2 px-3 sm:px-4 font-semibold ${currentView === 'inventory' ? 'active' : ''}`}
                    >
                        Estoque
                    </button>
                    <button 
                        onClick={() => setView('sales')} 
                        className={`nav-button py-2 px-3 sm:px-4 font-semibold ${currentView === 'sales' ? 'active' : ''}`}
                    >
                        Vendas
                    </button>
                    <button 
                        onClick={() => setView('customers')} 
                        className={`nav-button py-2 px-3 sm:px-4 font-semibold ${currentView === 'customers' || currentView === 'customerDetail' ? 'active' : ''}`}
                    >
                        Clientes
                    </button>
                    <button 
                        onClick={() => setView('financeiro')} 
                        className={`nav-button py-2 px-3 sm:px-4 font-semibold ${currentView === 'financeiro' ? 'active' : ''}`}
                    >
                        Recebimentos
                    </button>
                    <button 
                        onClick={() => setView('compromissos')} 
                        className={`nav-button py-2 px-3 sm:px-4 font-semibold ${currentView === 'compromissos' ? 'active' : ''}`}
                    >
                        Compromissos
                    </button>
                    <button 
                        onClick={() => setView('tesouraria')} 
                        className={`nav-button py-2 px-3 sm:px-4 font-semibold ${currentView === 'tesouraria' ? 'active' : ''}`}
                    >
                        Caixa
                    </button>

                    {isAdmin && (
                        <button 
                            onClick={() => setView('admin')} 
                            className={`nav-button py-2 px-3 sm:px-4 font-semibold ${currentView === 'admin' ? 'active' : ''}`}
                        >
                            Administração
                        </button>
                    )}
                </div>
                
                <div className="w-full sm:w-auto mt-2 sm:mt-0">
                    <button 
                        onClick={onLogout} 
                        className="w-full sm:w-auto nav-button-logout py-2 px-4 font-semibold rounded-lg text-sm"
                    >
                        Sair
                    </button>
                </div>
            </nav>
        </header>
    );
};

export default Header;